import { twMerge } from "tailwind-merge";
import { ErrorCard } from "./error-card";
import { ErrorComponent } from "./error-component";
import { Loading } from "./loading";
import { ErrorBoundary } from "react-error-boundary";
import * as Sentry from "@sentry/react"

interface WithErrorAndLoadingProps {
  error?: string | Error | null;
  loading: boolean;
  loadingClassName?: string;
  children: React.ReactNode;
  noLogo?: boolean;
  noSpinner?: true;
  mini?: true;
  retry?: () => any;
}

const logError = (error: Error, info: React.ErrorInfo) => {
  console.error("ErrorBoundary", error.message, info);
  const eventId = Sentry.captureException(error, { extra: { info } });
  console.log("Sentry event ID", eventId);
}

function CustomErrorBoundary({ error }: { error: Error }) {
  return <ErrorCard className="min-w-auto">
    <ErrorComponent error={error} />
  </ErrorCard>
}

export function WithErrorAndLoading({
  error,
  loading,
  loadingClassName,
  children,
  noLogo,
  noSpinner,
  mini,
  retry,
}: WithErrorAndLoadingProps) {
  if (error) {
    return mini ? (
      <ErrorComponent error={error} retry={retry} />
    ) : (
      <ErrorCard>
        <ErrorComponent error={error} retry={retry} />
      </ErrorCard>
    );
  }

  if (loading) {
    return (
      <Loading
        noSpinner={noSpinner}
        className={twMerge("flex-grow", loadingClassName)}
        noLogo={noLogo || mini}
      />
    );
  }

  return (
    <ErrorBoundary onError={logError} FallbackComponent={CustomErrorBoundary}>
      {children}
    </ErrorBoundary>
  );
}
